import { render, staticRenderFns } from "./ControlWidgets.vue?vue&type=template&id=23c9687e&scoped=true"
import script from "./ControlWidgets.vue?vue&type=script&lang=js"
export * from "./ControlWidgets.vue?vue&type=script&lang=js"
import style0 from "./ControlWidgets.vue?vue&type=style&index=0&id=23c9687e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c9687e",
  null
  
)

export default component.exports